import { Component, OnInit } from '@angular/core'
import { MetaService } from 'src/app/shared/services/meta.service'

import { Incentive } from '../../shared/interfaces/resources/incentive.interface'
import { BreadcrumbService } from '../../shared/services/breadcrumb.service'
import { FavoriteService } from '../../shared/services/favorite.service'
import { FilterService } from '../../shared/services/filter.service'
import { IncentiveService } from '../../shared/services/incentive.service'
import { IncentiveFamilyService } from '../../shared/services/incentive-family.service'
import { IncentiveFamily } from '../../shared/enums/incentive.family'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'app-comparator',
  templateUrl: './comparator.component.html',
  styleUrls: ['./comparator.component.scss']
})
export class ComparatorComponent implements OnInit {
  favoriteIncentiveIds: string[]
  loadingDownload: boolean = false
  savedFilters: { [key: string]: string[] } = {}
  families = this.incentiveFamilyService.families
  selectedFamily: IncentiveFamily;

  constructor(
    breadcrumbService: BreadcrumbService,
    private incentiveService: IncentiveService,
    private favoriteService: FavoriteService,
    private filterService: FilterService,
    private incentiveFamilyService: IncentiveFamilyService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    metaService: MetaService
  ) {
    metaService.setTags('comparator')
    breadcrumbService.breadcrumbLinks.next([{ label: 'Compare incentives' }])
  }

  ngOnInit(): void {
    this.changeFamily(this.incentiveFamilyService.family)
    this.loadFavoriteIncentives()
  }

  private loadFavoriteIncentives() {
    this.favoriteIncentiveIds = this.favoriteService.list({
      dataset: this.selectedFamily
    }).map((s) => s.id)
    this.savedFilters = this.filterService.getSavedFilters()
  }

  async downloadIncentives(incentiveIds: string[]): Promise<void> {
    this.loadingDownload = true
    await this.incentiveService.download(incentiveIds)
    this.loadingDownload = false
  }

  onOrderChanged(incentives: Incentive[]): void {
    this.favoriteService.replaceByNewValues(incentives, this.selectedFamily)
  }

  changeFamily(family: IncentiveFamily): void {
    this.selectedFamily = family
    this.incentiveFamilyService.setFamily(family)
    this.loadFavoriteIncentives()
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { dataset: family }
    })
  }

  protected readonly IncentiveFamily = IncentiveFamily
}
